export const termsAndConditionsAcceptedDateClaim = 'http://qsl.com/termsAndConditionsAcceptedDate';

export const formatAcceptedDate = (value, language) => {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return new Intl.DateTimeFormat(language, { dateStyle: 'long' }).format(date);
};
